export class TransportNote {
  transportId: number;
  note: string;
}
